export const listQuantityOperator = [
  {
    value: '>',
    label: '>'
  },
  {
    value: '>',
    label: '>'
  },
  {
    value: '>=',
    label: '>='
  },
  {
    value: '<=',
    label: '<='
  },
  {
    value: '=',
    label: '='
  }
];

export const listNextOperator = [
  {
    value: 1,
    label: 'Và'
  },
  {
    value: 2,
    label: 'Hoặc'
  }
];

export const amountOperator = [
  {
    value: '>',
    label: '>'
  },
  {
    value: '>',
    label: '>'
  },
  {
    value: '>=',
    label: '>='
  },
  {
    value: '<=',
    label: '<='
  },
  {
    value: '=',
    label: '='
  }
];
export const listProductType = [
  {
    value: 1,
    label: 'Bao gồm'
  },
  {
    value: 2,
    label: 'Ngoại trừ'
  }
];
